/**
 * CR313: Audit Log Tab
 * 
 * Placeholder for future audit log functionality.
 * Since the audit table migration was declined, this shows a message.
 */

import React from 'react';
import { AlertCircle, History } from 'lucide-react';

export function FeatureFlagsAuditTab() {
  return (
    <div className="flex flex-col items-center justify-center h-64 text-center p-8">
      <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-4">
        <History className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium mb-2">Audit Log Not Available</h3>
      <p className="text-sm text-muted-foreground max-w-md">
        The audit log feature requires a database migration to create the 
        <code className="mx-1 px-1 py-0.5 bg-muted rounded text-xs">feature_flags_audit</code> 
        table. Once enabled, all flag changes will be tracked here with timestamps and user info.
      </p>
    </div>
  );
}
